




































































































import { Component, Vue } from 'vue-property-decorator';
import RegisterService from '../services/RegisterService';

@Component
export default class SignUp extends Vue {
    private firstName: string = '';
    private lastName: string = '';
    private userName: string = '';
    private email: string = '';
    private password: string = '';
    private passwordConf: string = '';
    private error: string = '';
    private e1: boolean = true;
    private e2: boolean = true;
    private valid: boolean = false;
    private dialog: boolean = false;
    private loading: boolean = false;
    private snackbar: boolean = false;
    private snackbarText: string = '';
    private snackbarColor: string = '';

    private async register() {
        try {
            this.loading = true;
            await RegisterService.register({
              userName: this.userName,
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              password: this.password
            });
            this.dialog = true;
        } catch (e) {
            if (e.response && e.response.data && e.response.data.constraint === 'users_username_key') {
                this.displaySnackbar('User name already taken, please choose another one.', 'error');
            } else {
                this.displaySnackbar(e.message, 'error');
            }
        } finally {
            this.loading = false;
        }
    }

    private displaySnackbar(msg: string, color: string) {
        this.snackbarText = msg;
        this.snackbarColor = color;
        this.snackbar = true;
    }
}
